// extracted by mini-css-extract-plugin
export default {"editable":"InPlaceEditable-module__editable--Pi0OR","empty":"InPlaceEditable-module__empty--oaITB"};